module.exports = __webpack_public_path__ + "static/img/da2.cfb0ef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/da2.png
// module id = vEar
// module chunks = 1